<ng-container *ngIf="configuration.getToolbarUseCtzVersion() === false && showMenu">

    <mat-toolbar class="mat-elevation-z1">

        <div class="toolbar__left-container">

            <button
                *ngIf="!hiddenNavbar && !rightNavbar"
                fxHide.gt-md
                mat-icon-button
                class="toolbar__toggle-menu-button"
                data-e2e="nav-menu"
                aria-expanded="false"
                (click)="toggleSidebarOpen('navbar')"
                [attr.aria-label]="'generic.menu_close' | translate"
                aria-controls="navbar-vertical-2"
                [matTooltip]="'generic.menu' | translate">
                <mat-icon
                    class="secondary-text"
                    svgIcon="menu">
                </mat-icon>
            </button>

            @if (shouldDisplayRewardBar()) {
                <app-freemium-reward-progress-bar [triggersCount]="triggerCount">
                </app-freemium-reward-progress-bar>
            } @else if (shouldDisplayPremiumState()) {
                <app-premium-state [isActive]="premiumStateIsActive"
                                   [expirationDate]="premiumStateExpirationDate">
                </app-premium-state>
            }

            @if (authenticationService?.userData?.id && useLinkWithMailAndId() && authenticationService.isTrainer() && isSurveyActivate()) {
                <aside class="toolbar__survey">
                    <div class="toolbar__survey-message">{{ 'generic.header_redirect_msg' | translate }}</div>
                    <a class="toolbar__survey-link"
                        [href]="('generic.header_redirect_url' | translate) + mailAndIdForSurvey()"
                        target="_blank">
                        <span>{{ 'generic.header_redirect_url_msg' | translate }}</span>
                        <mat-icon svgIcon="open-in-new-rounded"></mat-icon>
                    </a>
                </aside>
            }

            @if (showTechnicalProblemMessage && !authenticationService.isGAR() && isMsgAllowed()) {
                <aside class="toolbar__message">
                    <p [innerHTML]="'generic.technical_problem' | translate"></p>
                </aside>
            }

            @if (showTechnicalProblemMessageGar && authenticationService.isGAR() && !useLinkWithMailAndId()) {
                <aside class="toolbar__message">
                    {{ 'generic.technical_problem_gar' | translate }}
                </aside>
            }

            @if (teacherWithAlmostTwoAssignment() && !showTechnicalProblemMessage && !showTechnicalProblemMessageGar) {
                <aside class="toolbar__message">
                    {{ 'generic.header_redirect_msg' | translate }}
                    <a target="_blank"
                    [href]="'generic.header_redirect_url' | translate">
                        {{ 'generic.header_redirect_url_msg' | translate }}
                    </a>
                </aside>
            }

            @if (showAsks()) {
                <div class="toolbar__message">
                    <span>{{ 'generic.header_redirect_msg' | translate }}</span>
                    <a target="_blank"
                    [href]="'generic.header_redirect_url' | translate">{{ 'generic.header_redirect_url_msg' | translate }}</a>
                    <span>{{ 'generic.header_redirect_msg_part2' | translate }}</span>
                </div>
            }

            <div class="toolbar-separator toolbar__separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div *ngIf="hiddenNavbar && horizontalNavbar"
                    class="toolbar__home-pseudo-button"
                    role="button"
                    tabindex="0"
                    data-e2e="toolbar-navigate-to-default"
                    (click)="navigateToDefaultRoute()"
                    (keyup.enter)="navigateToDefaultRoute()"
                    (keyup.space)="navigateToDefaultRoute()">
                <ng-container *ngIf="brandLogoSvg; else homeIconPngTemplate">
                    <mat-icon class="toolbar__home-icon-svg"
                                svgIcon="brand_square" aria-hidden="true">
                    </mat-icon>
                </ng-container>
                <ng-template #homeIconPngTemplate>
                    <img class="toolbar__home-icon-png"
                            src="assets/{{ brand }}/images/logos/brand-square.png"
                            aria-hidden="true">
                </ng-template>
                <mat-icon class="toolbar__home-chevron"
                            svgIcon="chevron-left-rounded-extra-light">
                </mat-icon>
                <div class="toolbar__home-wording">{{ 'navigation.home' | translate }}</div>
            </div>

        </div>

        <div class="toolbar__center-container">
        </div>

        <div class="toolbar__right-container">

            @if (IsFreemiumMode()) {
                <button class="toolbar__premium-upgrade-button"
                        data-e2e="toolbar-acces-premium"
                        (click)="openModalAccessPremium()">
                    <span>{{ 'toolbar.premium_upgrade' | translate }}</span>
                    <mat-icon svgIcon="toolbar__premium-action"></mat-icon>
                </button>
            }

            @if (showHelp) {
                <app-button-help [isMobileLayout$]="isMobileLayout$">
                </app-button-help>
            }

            @if (settings.showWebAppBtn && authenticationService.isAuthenticated === true && !authenticationService.isGAR()) {
                <ng-container *ngIf="{ isMobile: (isMobileLayout$ | async) } as layoutState">
                    <button class="toolbar__web-app-button"
                            [attr.aria-label]="layoutState.isMobile ? ('navigation.webapp.label' | translate) : null"
                            [matTooltip]="layoutState.isMobile ? ('navigation.webapp.label' | translate) : null"
                            data-e2e="toolbar-go-to-site"
                            (click)="goToSite('webapp.url')">
                        @if (!layoutState.isMobile) {
                            <mat-icon class="toolbar__web-app-logo"
                                    svgIcon="toolbar__web-app-logo">
                            </mat-icon>
                            <span class="toolbar__web-app-label">
                                {{ 'navigation.webapp.label' | translate }}
                            </span>
                        }
                        <mat-icon class="toolbar__web-app-icon"
                                svgIcon="toolbar__open-web-app">
                        </mat-icon>
                    </button>
                </ng-container>
            }

            <button *ngIf="shouldDisplayGoToLoginPage()" mat-button (click)="goToLoginPage()"
                    data-e2e="toolbar-go-to-login"
                    class="btn__goToLoginPage">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span>{{ 'authentication.btn-login' | translate }}</span>
                </div>
            </button>

            <ng-container *ngIf="activeLanguage$ | async as activeLanguage">
                <button *ngIf="showTranslateMenu && !this.hideLangueMenu"
                        class="language-button toolbar__language-button"
                        mat-button
                        fxHide
                        fxShow.gt-xs
                        data-e2e="toolbar-open-language-menu"
                        [matMenuTriggerFor]="languageMenu">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <mat-icon class="mr-8" *ngIf="!showFlagImg" svgIcon="earth"></mat-icon>
                        <img class="flag mr-8" *ngIf="showFlagImg && activeLanguage?.flag"
                                src="assets/{{ brand }}/images/flags/{{ activeLanguage.flag }}.png" alt="">
                        <span *ngIf="activeLanguage?.id"
                              class="toolbar__language-button-label">
                            {{ activeLanguage.id }}
                        </span>
                    </div>
                </button>
            </ng-container>

            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item *ngFor="let lang of languages" (click)="onLanguageClick(lang)" data-e2e="toolbar-lang-click">
                <span fxLayout="row" fxLayoutAlign="start center">
                    <img class="flag mr-16" *ngIf="showFlagImg"
                            src="assets/{{ brand }}/images/flags/{{lang.flag}}.png" alt="">
                    <span class="iso">{{ lang.title }}</span>
                </span>
                </button>

            </mat-menu>

            <div class="toolbar-separator toolbar__separator"></div>

            @if (authenticationService.isAuthenticated) {
                <ng-container *ngIf="{ isMobile: (isMobileLayout$ | async) } as layoutState">
                    <button class="toolbar__user-button user-button"
                            mat-button
                            data-e2e="toolbar-user-menu"
                            [matMenuTriggerFor]="userMenu"
                            [attr.aria-label]="'generic.user_menu' | translate"
                            [matTooltip]="'generic.user_menu' | translate">
                        <div class="toolbar__user-button-inner"
                            fxLayout="row"
                            fxLayoutAlign="center center">
                            <div class="toolbar__user-info account-info">
                                @if (userInformation && userInformation.get('picture') && brandLogoSvg) {
                                    <mat-icon class="logo-icon-svg toolbar__user-avatar avatar" svgIcon="brand_square_user-info"  aria-hidden="false" aria-label="image de l’avatar par défaut"></mat-icon>
                                } @else if (userInformation && userInformation.get('picture')) {
                                    <img class="toolbar__user-avatar avatar"
                                         [src]="userInformation?.get('picture')"
                                         alt="" />
                                }
                                @if (!layoutState.isMobile) {
                                    <div class="toolbar__user-labels account-labels mr-12">
                                        <span class="toolbar__username">
                                            {{ username }}
                                        </span>
                                        @if (isPremiumMode() && !isDemo()) {
                                            <div class="toolbar__premium-status">
                                                {{ 'fremium.tag_is_fremium' | translate }}
                                            </div>
                                        }
                                        @if (isRoleDisplayable()) {
                                            <span class="toolbar__user-role role">
                                                {{ 'toolbar.role_' + getRole() | translate }}
                                            </span>
                                        }
                                    </div>
                                }
                            </div>
                            <mat-icon class="toolbar__user-button-icon">
                                keyboard_arrow_down
                            </mat-icon>
                        </div>
                    </button>
                </ng-container>
            }

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item [routerLink]="'/profile/show-profile'" data-e2e="toolbar-user-menu-show-profile">
                    <mat-icon svgIcon="user"></mat-icon>
                    <span>{{ 'account-management.profile.title' | translate }}</span>
                </button>

                <button *ngIf="showContact()" mat-menu-item (click)="navigateToContact()" data-e2e="toolbar-navigate-to-contact">
                    <mat-icon svgIcon="help"></mat-icon>
                    <span>{{ 'navigation.contact' | translate }}</span>
                </button>

                <button *ngIf="showFeedBack()" mat-menu-item (click)="navigateToFeedback()" data-e2e="toolbar-navigate-to-feedback">
                    <mat-icon svgIcon="help"></mat-icon>
                    <span>{{ 'navigation.contact' | translate }}</span>
                </button>

                <button *ngIf="showFeedBackGar()" mat-menu-item (click)="navigateToFeedbackGar()" data-e2e="toolbar-navigate-to-feedback-gar">
                    <mat-icon svgIcon="help"></mat-icon>
                    <span>{{ 'navigation.contact' | translate }}</span>
                </button>

                <button *ngIf="showLicensing" mat-menu-item [routerLink]="'/profile/licensing'" data-e2e="toolbar-user-menu-show-licencing">
                    <mat-icon svgIcon="bookmark"></mat-icon>
                    <span>{{ 'account-management.profile.licensing.title' | translate }}</span>
                </button>

                <button mat-menu-item id="logout" class="" (click)="logOut()"
                        data-e2e="toolbar-logout"
                        *ngIf="!authenticationService.isGAR()">
                    <mat-icon svgIcon="log_out"></mat-icon>
                    <span>{{ 'account-management.logout' | translate }}</span>
                </button>

            </mat-menu>

            <div *ngIf="authenticationService.isAuthenticated" class="toolbar-separator toolbar__separator" fxHide fxShow.gt-xs></div>

            <button *ngIf="authenticationService.isAuthenticated && showNotification" mat-icon-button
                    class="quick-panel-toggle-button"
                    (click)="toggleSidebarOpen('quickPanel')"
                    data-e2e="toolbar-toogle-open-quickpanel"
                    aria-label="Toggle quick panel">
                <mat-icon class="icon">notifications</mat-icon>
                <span class="spacer"></span>
                <span class="badge" *ngIf="notificationsCount > 0">{{ notificationsCount }}</span>
            </button>

            <div class="toolbar-separator toolbar__separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" data-e2e="toolbar-opne-navbar" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator toolbar__separator" *ngIf="settingsTralereToolbar.displayed"></div>
            <!-- TRALALERE BAR -->
            <app-tralalere-bar *ngIf="settingsTralereToolbar.displayed"></app-tralalere-bar>
            <!-- / TRALALERE BAR -->

        </div>

    </mat-toolbar>

</ng-container>

<!--code from citizen code extract after fusion-->
<ng-container *ngIf="configuration.getToolbarUseCtzVersion() && showMenu">
    <mat-toolbar class="mat-elevation-z1 toolbar">

        <div class="toolbar__container"
             fxFlex
             fxFill
             fxLayout="row"
             fxLayoutAlign="start center">

            <div class="toolbar__left-content"
                 fxFlex="1 0 auto"
                 fxLayout="row"
                 fxLayoutAlign="start center">

                <button *ngIf="!hiddenNavbar && !rightNavbar"
                        class="navbar-toggle-button toolbar__menu-button"
                        mat-icon-button
                        fxHide.gt-md
                        data-e2e="nav-menu"
                        (click)="toggleSidebarOpen('navbar')"
                        [attr.aria-label]="'generic.menu' | translate"
                        [matTooltip]="'generic.menu' | translate">
                    <mat-icon class="secondary-text"
                              svgIcon="menu">
                    </mat-icon>
                </button>

                <div *ngIf="!hiddenNavbar && !rightNavbar"
                     class="toolbar-separator toolbar__separator"
                     fxHide.gt-md>
                </div>

                <div *ngIf="hiddenNavbar && horizontalNavbar"
                     class="toolbar__home-pseudo-button"
                     role="button"
                     tabindex="0"
                     data-e2e="toolbar-navigate-to-default-route"
                     (click)="navigateToDefaultRoute()"
                     (keyup.enter)="navigateToDefaultRoute()"
                     (keyup.space)="navigateToDefaultRoute()">
                    <ng-container *ngIf="brandLogoSvg; else homeIconPngTemplate">
                        <mat-icon class="toolbar__home-icon-svg"
                                  svgIcon="brand_square"
                                  aria-hidden="true">
                        </mat-icon>
                    </ng-container>
                    <ng-template #homeIconPngTemplate>
                        <img class="toolbar__home-icon-png"
                             src="assets/{{ brand }}/images/logos/brand-square.png"
                             aria-hidden="true">
                    </ng-template>
                    <mat-icon class="toolbar__home-chevron"
                              svgIcon="chevron-left-rounded-extra-light">
                    </mat-icon>
                    <div class="toolbar__home-wording">{{ 'navigation.home' | translate }}</div>
                </div>

            </div>

            <div class="toolbar__message"
                 [class.toolbar__message--citizen-code]="configuration.getToolbarUseCtzVersion()"
                 *ngIf="showTechnicalProblemMessage && isMsgAllowed()">
                <div [innerHTML]="'generic.technical_problem' | translate"></div>
            </div>

            <div class="toolbar__message" *ngIf="teacherWithAlmostTwoAssignment()">
                {{ 'generic.header_redirect_msg' | translate }}
                <a target="_blank"
                   [href]="'generic.header_redirect_url' | translate">{{ 'generic.header_redirect_url_msg' | translate }}</a>
            </div>

            <div class="toolbar__message" *ngIf="showAsks()">
                <span>{{ 'generic.header_redirect_msg' | translate }}</span>
                <a target="_blank"
                   [href]="'generic.header_redirect_url' | translate">{{ 'generic.header_redirect_url_msg' | translate }}</a>
                <span>{{ 'generic.header_redirect_msg_part2' | translate }}</span>
            </div>

            <div class="toolbar__right-content"
                 fxFlex="0 1 auto"
                 fxLayout="row"
                 fxLayoutAlign="start center">

                <app-button-help *ngIf="showHelp"
                                 class="toolbar__help-button">
                </app-button-help>

                <button *ngIf="shouldDisplayGoToLoginPage()"
                        class="btn__goToLoginPage toolbar__login-button"
                        mat-button
                        data-e2e="toolbar-navigate-to-login-page"
                        (click)="goToLoginPage()">
                    <div fxLayout="row"
                         fxLayoutAlign="center center">
                        <span>{{ 'authentication.btn-login' | translate }}</span>
                    </div>
                </button>

                <button *ngIf="showTranslateMenu && !this.hideLangueMenu"
                        class="language-button toolbar__language-button"
                        aria-label="langue"
                        mat-button
                        fxHide
                        fxShow.gt-xs
                        data-e2e="toolbar-open-language-menu-2"
                        [matMenuTriggerFor]="languageMenu">
                    <div fxLayout="row"
                         aria-label="langue"
                         fxLayoutAlign="center center">
                        <mat-icon *ngIf="!showFlagImg"
                                  class="mr-8"
                                  svgIcon="earth">
                        </mat-icon>
                        <img *ngIf="showFlagImg && selectedLanguage?.flag"
                             class="flag mr-8"
                             src="assets/{{ brand }}/images/flags/{{ selectedLanguage.flag }}.png"
                             alt="">
                        <span *ngIf="selectedLanguage?.id"
                              class="toolbar__language-button-label">
                        {{ selectedLanguage.id }}
                    </span>
                    </div>
                </button>

                <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

                    <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)" data-e2e="toolbar-set-lang">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img class="flag mr-16" *ngIf="showFlagImg"
                             src="assets/{{ brand }}/images/flags/{{lang.flag}}.png" alt="">
                        <span class="iso">{{ lang.title }}</span>
                    </span>
                    </button>

                </mat-menu>

                <div class="toolbar-separator toolbar__separator"></div>

                <button *ngIf="authenticationService.isAuthenticated"
                        class="user-button toolbar__user-button"
                        mat-button
                        data-e2e="toolbar-user-menu-2"
                        [matMenuTriggerFor]="userMenu"
                        [attr.aria-label]="'generic.user_menu' | translate"
                        [matTooltip]="'generic.user_menu' | translate">
                    <div class="toolbar__user-button-container"
                         fxLayout="row"
                         fxLayoutAlign="center center">
                        <div class="account-info toolbar__user-data">
                            @if (userInformation && !userInformation.get('picture') && brandLogoSvg) {
                                <mat-icon class="logo-icon-svg avatar" svgIcon="brand_square_user-info" aria-hidden="true"></mat-icon>
                            } @else if (userInformation && userInformation.get('picture')) {
                                <img class="avatar toolbar__user-avatar"
                                     [src]="userInformation?.get('picture')"
                                     alt="">
                            }
                            <div class="account-labels mr-12 toolbar__user-labels">
                            <span class="username toolbar__user-name"
                                  fxhide=""
                                  fxshow.gt-sm=""
                                  style="display: block;"
                                  _ngcontent-c3="">
                                {{ username }}
                            </span>
                                <span *ngIf="isRoleDisplayable()"
                                      class="role toolbar__user-role">
                                {{ 'toolbar.role_' + getRole() | translate }}
                            </span>
                            </div>
                        </div>
                        <mat-icon class="s-16 toolbar__user-button-icon"
                                  fxHide.xs
                                  svgIcon="user-menu">
                        </mat-icon>
                    </div>
                </button>

                <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                    <button mat-menu-item [routerLink]="'/profile/show-profile'" data-e2e="toolbar-user-menu-show-profile-2">
                        <mat-icon svgIcon="user"></mat-icon>
                        <span>{{ 'account-management.profile.title' | translate }}</span>
                    </button>

                    <button *ngIf="showContact()" mat-menu-item (click)="navigateToContact()" data-e2e="toolbar-navigate-to-contact-2">
                        <mat-icon svgIcon="help"></mat-icon>
                        <span>{{ 'navigation.contact' | translate }}</span>
                    </button>

                    <button *ngIf="showFeedBack()" mat-menu-item (click)="navigateToFeedback()" data-e2e="toolbar-navigate-to-feedback-2">
                        <mat-icon svgIcon="help"></mat-icon>
                        <span>{{ 'navigation.contact' | translate }}</span>
                    </button>

                    <button *ngIf="showFeedBackGar()" mat-menu-item (click)="navigateToFeedbackGar()" data-e2e="toolbar-navigate-to-feedback-gar-2">
                        <mat-icon svgIcon="help"></mat-icon>
                        <span>{{ 'navigation.contact' | translate }}</span>
                    </button>

                    <button *ngIf="showLicensing" mat-menu-item [routerLink]="'/profile/licensing'" data-e2e="toolbar-user-menu-show-licencing-2">
                        <mat-icon svgIcon="bookmark"></mat-icon>
                        <span>{{ 'account-management.profile.licensing.title' | translate }}</span>
                    </button>

                    <button mat-menu-item id="logout" class="" (click)="logOut()"
                            data-e2e="toolbar-navigate-to-logout-2"
                            *ngIf="!authenticationService.isGAR()">
                        <mat-icon svgIcon="log_out"></mat-icon>
                        <span>{{ 'account-management.logout' | translate }}</span>
                    </button>

                </mat-menu>

                <div *ngIf="authenticationService.isAuthenticated"
                     class="toolbar-separator toolbar__separator"
                     fxHide
                     fxShow.gt-xs>
                </div>

                @if (authenticationService.isAuthenticated && showNotification) {
                    <button class="toolbar__notification-button"
                            [class.toolbar__notification-button--unread]="hasNotifications"
                            [attr.aria-label]="'notification.title' | translate"
                            [matTooltip]="'notification.title' | translate"
                            data-e2e="toolbar-navigate-open-notif-2"
                            (click)="openNotifications()">
                            <mat-icon class="toolbar__notification-icon"
                                      [svgIcon]="hasNotifications ? 'toolbar__unread-notification' : 'toolbar__notification'">
                            </mat-icon>
                    </button>
                }

                <div *ngIf="!hiddenNavbar && rightNavbar"
                     class="toolbar-separator toolbar__separator"
                     fxHide
                     fxShow.gt-xs>
                </div>

                <button mat-icon-button class="navbar-toggle-button"
                        *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" data-e2e="toolbar-sidebar-open-navbar-2" fxHide.gt-md>
                    <mat-icon class="secondary-text">menu</mat-icon>
                </button>

                <div *ngIf="settingsTralereToolbar.displayed"
                     class="toolbar-separator toolbar__separator">
                </div>

                <!-- TRALALERE BAR -->
                <app-tralalere-bar *ngIf="settingsTralereToolbar.displayed"></app-tralalere-bar>
                <!-- / TRALALERE BAR -->

            </div>

        </div>

    </mat-toolbar>
</ng-container>
